import {Label} from '@app/components/elements/Label';
import {
  leaveSelector,
  setApplyedFilterData,
} from '@app/screens/leave-management/redux';
import {
  CheckBoxOutlineBlank,
  ExpandLess,
  ExpandMore,
} from '@mui/icons-material';
import {
  BottomNavigation,
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Paper,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import {useEffect, useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {useStyles} from './styles';
import {ToasterService} from '@app/services';
import {ToastType} from '@app/services/toaster';
// BSV CHANGES
import { fetchStatesByCountryIdCreator, fetchDivisionsByCountryIdCreator } from '@app/screens/leave-management/redux/slice';

// BSV CHANGES
type FilterOption = {
  countryId: string | number | null;
  id: number | string;
  value: string;
  isChecked?: boolean;
  isDisable?: boolean;
};
// BSV CHANGES
type FilterGroup = {
  filterData: FilterOption[];
  collapsed: boolean;
  isChecked?: boolean;
  isDisable?: boolean;
};

type Filters = Record<string, FilterGroup>;

const LeaveFilter = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const getLeaveFilterDataSelector = useSelector(
    leaveSelector.getLeaveFilterDataSelector(),
    shallowEqual,
    // BSV CHANGES
  ) as Filters;
  // BSV CHANGES
  const [filters, setFiltersState] = useState<Filters>({});
  const [filterComponents, setFilterComponent] = useState<JSX.Element>(<></>);
  const addFilterView = () => {
    setFilterComponent(getFilterLayout(filters));
  };
  useEffect(() => {
    filters && Object.keys(filters)?.length > 0
      ? addFilterView()
      : setFilterComponent(<></>);
  }, [filters]);

  useEffect(() => {
    getLeaveFilterDataSelector &&
    Object.keys(getLeaveFilterDataSelector)?.length > 0
      ? setFiltersState(getLeaveFilterDataSelector)
      : setFiltersState({});
  }, [getLeaveFilterDataSelector]);

  // const clearAllFilter = () => {
  //   setFiltersState(getLeaveFilterDataSelector);
  // };
  // BSV CHANGES On Clear India was not getting set that's why changed
  const clearAllFilter = async() => {
    const originalFilters = getLeaveFilterDataSelector;
    const updatedFilters: Filters = {};
  
    let indiaId: string | number | null = null;
  
    // Dynamically find India ID from "Country" filter
    if (originalFilters?.Country?.filterData?.length > 0) {
      const indiaEntry = originalFilters.Country.filterData.find(
        item => item.value.toLowerCase() === 'india'
      );
      indiaId = indiaEntry?.id ?? null;
    }
  
    Object.entries(originalFilters).forEach(([key, value]) => {
      updatedFilters[key] = {
        ...value,
        collapsed: true,
        filterData: value.filterData.map(item => {
          if (key === 'Country') {
            return {
              ...item,
              isChecked: item.id === indiaId,
            };
          }
          return {
            ...item,
            isChecked: false,
          };
        }),
        isChecked: key === 'Country' ? true : false,
      };
    });
  
    if (typeof indiaId === 'number') {
      dispatch(
        fetchStatesByCountryIdCreator({
          countryId: indiaId,
          currentFilter: updatedFilters,
        })
      );

       // Wait a short tick to ensure Redux updates filters before next dispatch
       await new Promise(resolve => setTimeout(resolve, 500));
            
       dispatch(fetchDivisionsByCountryIdCreator({
         countryId: indiaId,
         currentFilter: updatedFilters,
       }));
   
    }
  
    setFiltersState(updatedFilters);
  };
  
  // BSV CHANGES
  const alterOptionFilterAppliedState = async (
    state: any,
    parentKey: any,
    childKey: any,
  ) => {
    // Deep copy filters to avoid mutation
    const filtersCopy = JSON.parse(JSON.stringify(filters || {})) as Filters;
  
    if (filtersCopy[parentKey] && filtersCopy[parentKey].filterData) {
      if (parentKey === 'Country') {
        const prevSelectedCountryId = filtersCopy[parentKey].filterData.find(item => item.isChecked)?.id ?? null;
  
        const updatedCountryFilterData = filtersCopy[parentKey].filterData.map(item => ({
          ...item,
          isChecked: item.id === childKey.id ? state : false,
        }));
  
        filtersCopy[parentKey].filterData = updatedCountryFilterData;
        filtersCopy[parentKey].isChecked = state;
  
        const selectedCountryId = state ? childKey.id : null;
  
        if (selectedCountryId !== prevSelectedCountryId) {
          const updatedFilters = {
            ...filtersCopy,
            Country: {
              ...filtersCopy.Country,
              filterData: updatedCountryFilterData,
            },
          };
  
          // setFiltersState(updatedFilters);
  
          if (typeof selectedCountryId === 'number') {
            // Just dispatch both fetch actions in parallel (no comparison)
            dispatch(fetchStatesByCountryIdCreator({
              countryId: selectedCountryId,
              currentFilter: updatedFilters,
            }));
            
            // Wait a short tick to ensure Redux updates filters before next dispatch
            await new Promise(resolve => setTimeout(resolve, 500));
            
            dispatch(fetchDivisionsByCountryIdCreator({
              countryId: selectedCountryId,
              currentFilter: updatedFilters,
            }));
          } else {
            // Optionally clear states and divisions if no country selected
            // dispatch(clearStates());
            // dispatch(clearDivisions());
          }
  
          return;
        }
      } else {
        filtersCopy[parentKey].filterData = filtersCopy[parentKey].filterData.map(optionKey => ({
          ...optionKey,
          isChecked: optionKey.id === childKey.id ? state : optionKey.isChecked,
        }));
  
        const uncheckedChild = filtersCopy[parentKey].filterData.find(child => !child.isChecked);
        filtersCopy[parentKey].isChecked = getIsCheckedValue(uncheckedChild);
      }
    }
  
    setFiltersState(filtersCopy);
  };
  

  const alterAllAppliedState = (state: any, key: any) => {
    let updatedFilters = JSON.parse(JSON.stringify(filters ? filters : {}));
    const parentFilter = updatedFilters[key];
    // Toggle the isChecked state of the parent
    parentFilter.isChecked = state;
    // Mark all child filters as checked or unchecked
    parentFilter.filterData.forEach((filter: any) => {
      filter.isChecked = state;
    });
    const replaceUpdateObj = {
      ...filters,
      [key]: parentFilter,
    };
    setTimeout(() => {
      setFiltersState(replaceUpdateObj);
    }, 0);
  };

  const getIsCheckedValue = (value: any) => {
    return value ? false : true;
  };

  const handleChildCheckbox = (parentKeyName: string, childKey: any) => {
    alterOptionFilterAppliedState(
      !childKey?.isChecked,
      parentKeyName,
      childKey,
    );
  };

  const handleParentCheckbox = (parentKeyName: string, filter: any) => {
    alterAllAppliedState(!filter?.isChecked, parentKeyName);
  };

  const checkIfIndeterminate = (list: any, filter: any) => {
    if (filter.isChecked) return false;
    let isIndeterminate = list?.find((item: any) => item.isChecked);
    return isIndeterminate ? true : false;
  };
  const handleAppleyedFilterOutput = () => {
    // Initialize empty lists
    const statusList: any[] = [];
    const leaveTypeList: any[] = [];
    const stateList: any[] = [];
    const divisionList: any[] = [];
    const userStatusList: any[] = [];
    // BSV CHANGES added in Leavehistory api, country level check
    const countryId = filters?.Country?.filterData?.find((item: any) => item.isChecked)?.id ?? null;
    // Iterate over each filter entry
    Object.entries<any>(filters).forEach(([key, value]) => {
      // Skip "Country" filter
      if (key === 'Country') return;
      // Extract filterData array and construct list based on key
      const list = value.filterData
        .filter((item: any) => item.isChecked)
        .map((item: any) => {
          if (key === 'Approval status') {
            return {statusId: item.id};
          } else if (key === 'Leave Type') {
            return {leaveTypeId: item.id};
          } else if (key === 'State') {
            return {stateId: item.id};
          } else if (key === 'Division') {
            return {divisionId: item.id};
          } else if (key === 'User Status') {
            return {userStatus: item.id};
          }
        });
      // Push constructed list to the respective list
      if (key === 'Approval status') {
        statusList.push(...list);
      } else if (key === 'Leave Type') {
        leaveTypeList.push(...list);
      } else if (key === 'State') {
        stateList.push(...list);
      } else if (key === 'Division') {
        divisionList.push(...list);
      } else if (key === 'User Status') {
        userStatusList.push(...list);
      }
    });
    // Construct final output object
    const output: any = {
       // BSV CHANGES added in Leavehistory api, country level check
      countryId: countryId,
      statusList: statusList,
      leaveTypeList: leaveTypeList,
      stateList: stateList,
      divisionList: divisionList,
      userStatusList: userStatusList,
    };
    return output;
  };
  const applyFilters = () => {
    const output = handleAppleyedFilterOutput();
    // Check if statusList and User status is empty
    if (output?.statusList?.length === 0) {
      ToasterService.showToaster(
        'Please select at least one approval status type.',
        ToastType.ERROR,
      );
    } else if (output?.userStatusList?.length === 0) {
      ToasterService.showToaster(
        'Please select at least one user status.',
        ToastType.ERROR,
      );
    } else {
      console.log(output, "OOOOOOOO")
      dispatch(setApplyedFilterData(output));
    }
  };

  const getExpandIcon = (collapsed: boolean) => {
    if (collapsed) return <ExpandMore />;
    else return <ExpandLess />;
  };

  const listItemText = (text: string) => (
    <Label title={text} classes={classes.listItemText} />
  );

  const parentListItemText = (text: string) => (
    <Label title={text} classes={classes.parentListItemText} />
  );

  const getFilterLayout = (filtersObj: any) => {
    let filterItems: any = [];
    Object.keys(filtersObj).forEach(key => {
      filterItems.push(secondaryListItems(filtersObj[key], key));
    });
    return <Box paddingBottom={'100px'}>{filterItems}</Box>;
  };
  const handleParentListItemClick = (parentKeyName: string) => {
    let updatedZonesData = JSON.parse(JSON.stringify(filters ? filters : {}));
    updatedZonesData[parentKeyName].collapsed =
      !updatedZonesData[parentKeyName].collapsed;
    setFiltersState(updatedZonesData);
  };
  const secondaryListItems = (filter: any, parentKeyName: any) => {
    return (
      <>
        {filter ? (
          <Box marginBottom={'15px'} marginLeft={'10px'}>
            <ListItem
              disablePadding
              button
              key={parentKeyName}
              onClick={() => handleParentListItemClick(parentKeyName)}
              data-testid={`list_item_${parentKeyName}`}>
              <ListItemIcon>
                {/* // BSV CHANGES */}
                <Checkbox
                  className={classes.checkbox}
                  checked={parentKeyName === 'Country' ? false : filter?.isChecked || false}
                  indeterminate={parentKeyName === 'Country' ? true : checkIfIndeterminate(
                    filter?.filterData,
                    filter,
                  )}
                  disabled={parentKeyName === 'Country' || filter?.isDisable || false}
                  indeterminateIcon={<IndeterminateIcon />}
                  onClick={event => {
                    if (parentKeyName !== 'Country') {
                      handleParentCheckbox(parentKeyName, filter);
                    }
                  }}
                  data-testid={`parent_${parentKeyName}`}
                />
              </ListItemIcon>
              {parentListItemText(parentKeyName)}
              <Box paddingRight={'10px'}>
                {getExpandIcon(filter?.collapsed)}
              </Box>
            </ListItem>

            <Collapse in={!filter?.collapsed} timeout="auto" unmountOnExit>
              <List
                component="div"
                disablePadding
                className={classes.marginLeft15}>
                {filter?.filterData?.map((childKey: any) => {
                  return (
                    <>
                      <ListItem
                        disablePadding
                        button
                        key={`${parentKeyName}_${childKey?.id}`}
                        data-testid={`list_item_${childKey?.id}`}>
                        <ListItemIcon>
                          <Checkbox
                            className={classes.checkbox}
                            checked={childKey?.isChecked || false}
                            disabled={childKey?.isDisable || false}
                            indeterminateIcon={<IndeterminateIcon />}
                            onClick={event => {
                              handleChildCheckbox(parentKeyName, childKey);
                            }}
                            data-testid={`option_${parentKeyName}_${childKey?.id}`}
                          />
                        </ListItemIcon>
                        {listItemText(childKey?.value)}
                      </ListItem>
                    </>
                  );
                })}
              </List>
            </Collapse>
          </Box>
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <>
      <Box
        margin={'20px'}
        marginTop={'10px'}
        borderRadius={'20px'}
        className={`${classes.backgroundWhite} hide-scrollbar`}
        height={'100vh'}
        overflow={'scroll'}>
        {filters && Object.keys(filters)?.length > 0 ? (
          <>
            <Box
              display={'flex'}
              justifyContent="space-between"
              marginBottom={'10px'}
              padding={'10px'}>
              <Chip
                label="Filter"
                size="small"
                className={classes.chipFilter}
              />
              <Chip
                label="Reset"
                size="small"
                clickable
                onClick={clearAllFilter}
                className={classes.chipClearAll}
                data-testid="clear-filters"
              />
            </Box>

            {filterComponents}

            <Paper className={`${classes.paper} height-100`} elevation={3}>
              <BottomNavigation showLabels value={0}>
                <Box className={classes.applyBox}>
                  <Button
                    variant="contained"
                    onClick={applyFilters}
                    className={classes.paperButton}
                    data-testid={'apply_filters'}>
                    Apply
                  </Button>
                </Box>
              </BottomNavigation>
            </Paper>
          </>
        ) : (
          <Box sx={{display: 'flex', justifyContent: 'center', mt: 2}}>
            <CircularProgress size={20} />
          </Box>
        )}
      </Box>
    </>
  );
};

const IndeterminateIcon = () => {
  const classes = useStyles();

  return (
    <>
      <CheckBoxOutlineBlank />
      <div className={classes.indeterminateBox} />
    </>
  );
};

export default LeaveFilter;
